<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CATG_GRP_NM')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="categoryName"
              placeholder
              maxlength="50"
              :disabled="false"
              :readonly="false"
              @input="specialChar(categoryName)"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CATG_GRP_ID')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              BCG_
            </div>
            <div class="comp_spacing" />
            <div class="comm_label">
              {{ categoryId }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DESC')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model="categoryContent"
              placeholder
              maxlength="1000"
              :disabled="false"
              :readonly="false"
            />
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="gridN"
        :columns="gridColumns0"
        :dataset="'dataset0'"
        :showDisplayCountControl="true"
        :rowMovable="true"
        :multiselect="false"
        :pageable="false"
        @rowselect="onSelectRow"
      >
        <div class="btn_wrapL">
          <div class="comp_spacing" />
          <sui-button
            v-permission:update="contextPageId"
            type="button"
            class="comm_btn_gridTop"
            @click="onClickAddRow"
          >
            {{ $t('MSG_BTN_ROW_ADD') }}
          </sui-button>
          <sui-button
            v-permission:update="contextPageId"
            type="button"
            class="comm_btn_gridTop"
            :disabled="deleteStatus"
            @click="onClickDeleteRow"
          >
            {{ $t('MSG_BTN_ROW_DEL') }}
          </sui-button>
        </div>
      </sui-grid>
    </div>
    <div class="comm_btn_wrap mrB30 mrR30">
      <div class="btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onPopupCancelClicked"
        >
          {{ $t('MSG_BTN_CLOSE') }}
        </sui-button>
        <sui-button
          v-permission:update="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="applyModification"
        >
          {{ $t('MSG_BTN_SAVE') }}
        </sui-button>
      </div>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CLB_00007_P02', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    biddingInformationParam: {
      type: Array,
      default() {
        return [];
      },
    },
  }, // eslint-disable-line vue/name-property-casing
  data() {
    return {
      categoryContent: '',
      maxArrayl: 0,
      categoryId: '',
      deleteStatus: true,
      categoryName: '',
      isemptyOrder: false,
      isemptyItem: false,
      isEmptydata: false,
    };
  },
  computed: {},
  watch: {},
  datasets: [
    {
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [
        {
          name: 'bullBoardCategoryItemName',
          type: 'string',
          map: 'bullBoardCategoryItemName',
        },
        {
          name: 'firstRegistrationUserId',
          type: 'string',
          map: 'firstRegistrationUserId',
        },
        {
          name: 'firstRegistrationDTM',
          type: 'string',
          map: 'firstRegistrationDTM',
        },
        {
          name: 'bullBoardCategoryItemID',
          type: 'string',
          map: 'bullBoardCategoryItemID',
        },
        {
          name: 'arraylOrder',
          type: 'string',
          map: 'arraylOrder',
        },
        {
          name: 'status',
          type: 'string',
          map: 'status',
        },
        {
          name: 'bullBoardCategoryItemMultiLanguageId',
          type: 'string',
          map: 'bullBoardCategoryItemMultiLanguageId',
        },
        { type: 'array', name: 'categoryItemMultiLanguageList', map: 'categoryItemMultiLanguageList' },
      ],
    },
  ],
  created() {
    this.gridColumns0 = [
      {
        text: this.$t('MSG_TXT_NUMBER_ROW'),
        datafield: '',
        cellsalign: 'center',
        editable: false,
        width: 80,
        cellsrenderer: (row, column, value) => `<div style="margin: 8.2px;">${row + 1}</div>`,
      },
      {
        text: this.$t('MSG_TXT_CATG_GRP_ITEM'),
        datafield: 'categoryItemMultiLanguageList',
        createwidget: (row, column, value, htmlElement) => {
          const instance = utils
            .getGridCellFactory()
            .createCellMlngEditor(
              row,
              column,
              value,
              htmlElement,
              {
                pageId: this.contextPageId,
                multiLanguageIdField: 'bullBoardCategoryItemMultiLanguageId',
              },
              this.dataset0,
              this.$refs.gridN,
            );
          instance.getComponentInstance().$on('mlng-changed', () => {
            const rowindex = instance.getDatasetIndex();
            if (!utils.isEqual(this.dataset0.data[rowindex].status, 'new')) {
              this.dataset0.data[rowindex].status = 'modified';
            }
          });
        },
        initwidget(row, column, value, htmlElement) {
          utils
            .getGridCellFactory()
            .refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_ARRAY_ORDER'),
        datafield: 'arraylOrder',
        editable: true,
        createwidget: (row, column, value, htmlElement) => {
          utils
            .getGridCellFactory()
            .createCellTextField(
              row,
              column,
              value,
              htmlElement,
              {
                trim: true,
                maxlength: '2',
                mask: 'number',
              },
              this.dataset0,
              this.$refs.gridN,
            );
        },
        initwidget(row, column, value, htmlElement) {
          utils
            .getGridCellFactory()
            .refreshCell(row, column, value, htmlElement);
        },
        width: 100,
      },
      {
        text: this.$t('MSG_TXT_RGST_USR'),
        datafield: 'firstRegistrationUserId',
        createwidget: (row, column, value, htmlElement) => {
          utils
            .getGridCellFactory()
            .createCellUserName(
              row,
              column,
              value,
              htmlElement,
              {
                displayType: '1', // "1", "2" - default: "1"
                type: 'link', // 'link', 'sublink' - default: "link"
                loginId: 'loginId',
              },
              this.dataset0,
              this.$refs.gridN,
            );
        },
        initwidget(row, column, value, htmlElement) {
          utils
            .getGridCellFactory()
            .refreshCell(row, column, value, htmlElement);
        },
        width: 100,
      },
      {
        text: this.$t('MSG_TXT_RGST_DT'),
        datafield: 'firstRegistrationDTM',
        width: 150,
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dataset0, this.$refs.gridN),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
      },
    ];
    this.localdata0 = [];
    this.beforeDeleteGridData = [];
  },
  mounted() {
    if (this.biddingInformationParam[0].bullBoardCategoryItemName) {
      this.dataset0.setRawData(this.biddingInformationParam);
    }
    this.categoryContent = this.biddingInformationParam[0].bullBoardCategoryGroupContent;
    this.categoryId = this.biddingInformationParam[0].bullBoardCategoryGroupID.slice(4,
      this.biddingInformationParam[0].bullBoardCategoryGroupID.length);

    const resultArr = this.biddingInformationParam.map(x => x.bullBoardCategoryItemID.substring(
      x.bullBoardCategoryItemID.lastIndexOf('_0') + 2,
    ));
    this.maxArrayl = Math.max(...resultArr, 0);
    this.beforeDeleteGridData = utils.clone(this.dataset0.data);
    this.categoryName = this.biddingInformationParam[0].bullBoardCategoryGroupName;
  },
  methods: {
    specialChar(value) {
      if (utils.isExistSpecialChar(value)) {
        utils.messageBox(
          'warning',
          this.$t('MSG_ALT_CHK_SPECL_CHAR'),
          null,
          () => {
            if (value === this.categoryName) this.categoryName = '';
            else if (value === this.categoryContent) this.categoryContent = '';
          },
        );
      }
    },
    onClickDeleteRow() {
      const positiveHandler = this.deleteItem;
      utils.messageBox(
        'confirm',
        this.$t('MSG_ALT_IS_DEL_DATA'),
        null,
        positiveHandler,
      );
    },
    onSelectRow() {
      this.deleteStatus = false;
    },

    deleteItem() {
      const categoryGroupId = `BCG_${this.categoryId}`;
      const selectedIndexes = this.dataset0.getSelectedIndexes();
      if (this.dataset0.data[selectedIndexes].status === 'new') {
        this.dataset0.deleteRows(selectedIndexes);
        this.deleteStatus = true;
      } else {
        http
          .request(this.contextPageId, 'DTS_CLB_00058', {
            path: {
              'item-id': this.dataset0.data[selectedIndexes]
                .bullBoardCategoryItemID,
              'category-group-id': categoryGroupId,
            },
          })
          .then(res => {
            if (res.data.resultCode === '1') {
              utils.messageBox(
                'error',
                this.$t('MSG_ALT_REL_CATG_POSTING'),
                null,
              );
            } else {
              http
                .request(this.contextPageId, 'DTS_CLB_00059', {
                  path: {
                    'item-id': this.dataset0.data[selectedIndexes]
                      .bullBoardCategoryItemID,
                    'category-group-id': categoryGroupId,
                  },
                })
                .then(res => {
                  if (res.data.resultCode === '1') {
                    this.deleteStatus = true;
                    utils.messageBox(
                      'success',
                      this.$t('MSG_ALT_PRGS_OK'),
                      null,
                    );
                    this.dataset0.deleteRows(selectedIndexes);
                    this.deleteStatus = true;
                  }
                });
            }
          });
      }
    },
    applyModification() {
      this.isemptyItem = false;
      this.isemptyItem = false;
      this.isemptyOrder = false;

      if (this.dataset0.data.length < 1) {
        this.isEmptydata = true;
      }
      this.dataset0.data.forEach(element => {
        if (element.bullBoardCategoryItemName === '') {
          // this.isemptyItem = true;
        }
        if (!element.arraylOrder) {
          this.isemptyOrder = true;
        }
      });
      if (!this.categoryName.trim()) {
        utils.messageBox(
          'warning',
          utils.strFormat(
            this.$t('MSG_ALT_INPUT_CELL'),
            this.$t('MSG_TXT_CATG_GRP_NM'),
            null,
          ),
        );
      } else if (!this.categoryContent.trim()) {
        utils.messageBox(
          'warning',
          utils.strFormat(
            this.$t('MSG_ALT_INPUT_CELL'),
            this.$t('MSG_TXT_DESC'),
            null,
          ),
        );
      } else if (this.isEmptydata) {
        utils.messageBox(
          'warning',
          utils.strFormat(
            this.$t('MSG_ALT_INPUT_CELL'),
            this.$t('MSG_TXT_CATG_GRP_ITEM'),
            null,
          ),
        );
      } else if (this.isemptyItem) {
        utils.messageBox(
          'warning',
          utils.strFormat(
            this.$t('MSG_ALT_INPUT_CELL'),
            this.$t('MSG_TXT_CATG_GRP_ITEM'),
            null,
          ),
        );
      } else if (this.isemptyOrder) {
        utils.messageBox(
          'warning',
          utils.strFormat(
            this.$t('MSG_ALT_INPUT_CELL'),
            this.$t('MSG_TXT_ARRAY_ORDER'),
          ),
          null,
        );
      } else {
        const positiveHandler = this.submitRequest;

        utils.messageBox(
          'confirm',
          this.$t('MSG_ALT_IS_SAV_DATA'),
          null,
          positiveHandler,
        );
      }
    },
    submitRequest() {
      const categoryItemlist = [];
      const categoryGroupId = `BCG_${this.categoryId}`;
      utils.forEach(this.dataset0.data, row => {
        const find = utils.find(row.categoryItemMultiLanguageList, { langId: this.$store.getters.userInfo.langId });
        const data = {
          arraylOrder: row.arraylOrder,
          bullBoardCategoryGroupID: categoryGroupId,
          bullBoardCategoryGroupName: this.categoryName.trim(),
          bullBoardCategoryGroupContent: this.categoryContent.trim(),
          bullBoardCategoryItemName: !utils.isEmpty(find) ? find.multiLanguageContent : row.bullBoardCategoryItemName,
          bullBoardCategoryItemID: row.bullBoardCategoryItemID,
          categoryItemMultiLanguageList: !utils.isEmpty(find) ? row.categoryItemMultiLanguageList : [],
          status: row.status,
        };
        categoryItemlist.push(data);
      });
      http
        .request(this.contextPageId, 'DTS_CLB_00038', {
          data: categoryItemlist,
        })
        .then(res => {
          if (res.data.resultCode === '1') {
            utils.messageBox('success', this.$t('MSG_ALT_PRGS_OK'), null);
          }
          this.$emit('exit', 'modify');
        });
    },
    onPopupCancelClicked() {
      this.$emit('exit', 'cancelModify');
    },

    onClickAddRow() {
      const dateObj = new Date();
      this.maxArrayl = this.maxArrayl + 1;
      const FORMAT_STR_SERVER = 'YYYYMMDDHHmmss';
      const categoryItemId = `BCG_${this.categoryId}_0${this.maxArrayl}`;
      const registrationdate = utils.toStringByFormat(dateObj, FORMAT_STR_SERVER);
      const defaultRow = [
        {
          firstRegistrationDTM: registrationdate,
          knoxId: this.$store.getters.userInfo.knoxId,
          userName: this.$store.getters.userInfo.userName,
          userGlobalName: this.$store.getters.userInfo.userGlobalName,
          bullBoardCategoryItemName: '',
          status: 'new',
          bullBoardCategoryItemID: categoryItemId,
        },
      ];
      this.dataset0.addRows(defaultRow, true);
    },
  },
};
</script>
<style scoped>
</style>
